import { render } from "./GameFooter.vue?vue&type=template&id=2a8d5c05&scoped=true"
const script = {}

import "./GameFooter.vue?vue&type=style&index=0&id=2a8d5c05&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a8d5c05"

export default script